export function rgbToHsv(r, g, b) {
  let h;
  let s;

  const rabs = r / 255;
  const gabs = g / 255;
  const babs = b / 255;
  const v = Math.max(rabs, gabs, babs);
  const diff = v - Math.min(rabs, gabs, babs);
  const diffc = c => (v - c) / 6 / diff + 1 / 2;
  const percentRoundFn = num => Math.round(num * 100) / 100;
  if (diff === 0) {
    h = s = 0;
  } else {
    s = diff / v;
    const rr = diffc(rabs);
    const gg = diffc(gabs);
    const bb = diffc(babs);

    if (rabs === v) {
      h = bb - gg;
    } else if (gabs === v) {
      h = (1 / 3) + rr - bb;
    } else if (babs === v) {
      h = (2 / 3) + gg - rr;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return {
    h: Math.round(h * 360),
    s: percentRoundFn(s * 100),
    v: percentRoundFn(v * 100)
  };
}

export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export function rgbToHex(r, g, b) {
  function hex(x) {
      return ('0' + parseInt(x).toString(16)).slice(-2);
  }
  return '#' + hex(r) + hex(g) + hex(b);
}

export function hsvToRgb(hue, saturation, value) {
  const h = hue / 60;
  const s = saturation / 100;
  let v = value / 100;
  const hi = Math.floor(h) % 6;

  const f = h - Math.floor(h);
  const p = 255 * v * (1 - s);
  const q = 255 * v * (1 - (s * f));
  const t = 255 * v * (1 - (s * (1 - f)));
  v *= 255;

  let rgbArray;
  switch (hi) {
    case 0:
      rgbArray = [v, t, p];
      break;
    case 1:
      rgbArray = [q, v, p];
      break;
    case 2:
      rgbArray = [p, v, t];
      break;
    case 3:
      rgbArray = [p, q, v];
      break;
    case 4:
      rgbArray = [t, p, v];
      break;
    case 5:
      rgbArray = [v, p, q];
      break;
  }

  return {
    r: rgbArray[0],
    g: rgbArray[1],
    b: rgbArray[2],
  };
}

export function hsvToHex(h, s, v) {
  const rgbColor = hsvToRgb(h, s, v);
  return rgbToHex(rgbColor.r, rgbColor.g, rgbColor.b);
}
